import Icon from '../interfaces/Icon'

const eighteenWheelerTruck: Icon = {
  name: 'Eighteen Wheel Truck',
  url: '/icons/ground/18-truck.png',
  greyUrl: '/icons/ground/18-truck-g.png',
  width: 217,
  height: 175
}

const eighteenWheelerTrailer: Icon = {
  name: 'Eighteen Wheel Trailer',
  url: '/icons/ground/18-trailer.png',
  greyUrl: '/icons/ground/18-trailer-g.png',
  width: 305,
  height: 255
}

const ambulance: Icon = {
  name: 'Ambulance',
  url: '/icons/ground/ambulance.png',
  greyUrl: '/icons/ground/ambulance-g.png',
  width: 206,
  height: 186
}

const ambus: Icon = {
  name: 'Ambus',
  url: '/icons/ground/ambus.png',
  greyUrl: '/icons/ground/ambus-g.png',
  width: 311,
  height: 228
}

const boat: Icon = {
  name: 'Boat',
  url: '/icons/ground/boat.png',
  greyUrl: '/icons/ground/boat-g.png',
  width: 311,
  height: 228
}

const brushTruck: Icon = {
  name: 'Brush Truck',
  url: '/icons/ground/brush.png',
  greyUrl: '/icons/ground/brush-g.png',
  width: 174,
  height: 135
}

const bus: Icon = {
  name: 'Coach Bus',
  url: '/icons/ground/ambus.png',
  greyUrl: '/icons/ground/ambus-g.png',
  width: 311,
  height: 228
}

const helicopter: Icon = {
  name: 'Helicopter',
  url: '/icons/air/helicopter.png',
  greyUrl: '/icons/air/helicopter-g.png',
  special: '/icons/air/helicopter-non.png',
  width: 281,
  height: 204
}

const truck: Icon = {
  name: 'Truck',
  url: '/icons/ground/truck.png',
  greyUrl: '/icons/ground/truck-g.png',
  width: 170,
  height: 124
}

const fireEngine: Icon = {
  name: 'Fire Ladder',
  url: '/icons/ground/fire-engine.png',
  greyUrl: '/icons/ground/fire-engine-g.png',
  width: 296,
  height: 216
}

const pumper: Icon = {
  name: 'Fire Pumper',
  url: '/icons/ground/fire-pumper.png',
  greyUrl: '/icons/ground/fire-pumper-g.png',
  width: 278,
  height: 212
}

const tender: Icon = {
  name: 'Fire Tender',
  url: '/icons/ground/fire-tender.png',
  greyUrl: '/icons/ground/fire-tender-g.png',
  width: 250,
  height: 196
}

const mental: Icon = {
  name: 'Mental Health Unit',
  url: '/icons/ground/suburban-mental.png',
  greyUrl: '/icons/ground/suburban-mental-g.png',
  width: 156,
  height: 125
}

const suburban: Icon = {
  name: 'Suburban',
  url: '/icons/ground/suburban.png',
  greyUrl: '/icons/ground/suburban-g.png',
  width: 156,
  height: 125
}

export const icons: { [key: string]: Icon } = {
  AMB2: ambulance,
  ambulance: ambulance,
  AMBUS: ambus,
  boat: boat,
  BRUSH: brushTruck,
  BT: brushTruck,
  bus: bus,
  car: suburban,
  COACH: bus,
  EIGHTTRAILER: eighteenWheelerTrailer,
  EIGHTTRUCK: eighteenWheelerTruck,
  ENGINE: fireEngine,
  ENGINE2: fireEngine,
  jeep: suburban,
  LADDER: fireEngine,
  MAC: helicopter,
  MEDIC: ambulance,
  MENTAL: mental,
  MOF: suburban,
  PUMPER: pumper,
  SQUAD: suburban,
  SUB2: suburban,
  TENDER: tender,
  TIFMAS: truck,
  TRUCK: truck,
  TRUCK2: truck,
  ZODIAC: boat,
  helicopter: helicopter
}
